import React, { useState } from 'react';
import { FaWarehouse, FaPlus, FaEdit, FaMapMarkerAlt, FaCheck, FaTrash } from 'react-icons/fa';

const SellerWarehouse = () => {
    const [warehouses, setWarehouses] = useState([
        {
            id: 1,
            name: 'Main Warehouse - Bhubaneswar',
            address: '123 Industrial Area, Chandrasekharpur, Bhubaneswar, Odisha 751024',
            contact: '+91 9876543210',
            manager: 'Rajesh Kumar',
            isPrimary: true,
            productsStored: 156,
            capacity: 80,
        },
        {
            id: 2,
            name: 'Secondary Warehouse - Cuttack',
            address: '45 Nayasarak, Cuttack, Odisha 753001',
            contact: '+91 9876543211',
            manager: 'Priya Mohapatra',
            isPrimary: false,
            productsStored: 78,
            capacity: 45,
        },
    ]);

    const [showAddModal, setShowAddModal] = useState(false);

    return (
        <div className="p-6">
            <div className="mb-6 flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Warehouse Management</h1>
                    <p className="text-gray-600">Manage your storage locations and inventory distribution</p>
                </div>
                <button
                    onClick={() => setShowAddModal(true)}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                >
                    <FaPlus /> Add Warehouse
                </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-blue-500">
                    <p className="text-gray-500 text-sm">Total Warehouses</p>
                    <p className="text-2xl font-bold text-gray-800">{warehouses.length}</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-green-500">
                    <p className="text-gray-500 text-sm">Total Products</p>
                    <p className="text-2xl font-bold text-gray-800">{warehouses.reduce((sum, w) => sum + w.productsStored, 0)}</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-yellow-500">
                    <p className="text-gray-500 text-sm">Avg. Capacity Used</p>
                    <p className="text-2xl font-bold text-gray-800">{Math.round(warehouses.reduce((sum, w) => sum + w.capacity, 0) / warehouses.length)}%</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow border-l-4 border-purple-500">
                    <p className="text-gray-500 text-sm">Active Locations</p>
                    <p className="text-2xl font-bold text-gray-800">{warehouses.length}</p>
                </div>
            </div>

            {/* Warehouse Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {warehouses.map((warehouse) => (
                    <div key={warehouse.id} className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="p-6">
                            <div className="flex justify-between items-start mb-4">
                                <div className="flex items-center gap-3">
                                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                                        <FaWarehouse className="text-blue-600 text-xl" />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">{warehouse.name}</h3>
                                        {warehouse.isPrimary && (
                                            <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded">Primary</span>
                                        )}
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    <button className="p-2 text-gray-500 hover:bg-gray-100 rounded">
                                        <FaEdit />
                                    </button>
                                    {!warehouse.isPrimary && (
                                        <button className="p-2 text-red-500 hover:bg-red-50 rounded">
                                            <FaTrash />
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="space-y-3 text-sm">
                                <div className="flex items-start gap-2">
                                    <FaMapMarkerAlt className="text-gray-400 mt-1" />
                                    <span className="text-gray-600">{warehouse.address}</span>
                                </div>
                                <div className="grid grid-cols-2 gap-4 mt-4">
                                    <div>
                                        <p className="text-gray-500">Manager</p>
                                        <p className="font-medium">{warehouse.manager}</p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500">Contact</p>
                                        <p className="font-medium">{warehouse.contact}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-4 pt-4 border-t">
                                <div className="flex justify-between items-center mb-2">
                                    <span className="text-sm text-gray-500">Storage Capacity</span>
                                    <span className="text-sm font-medium">{warehouse.capacity}%</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full">
                                    <div
                                        className={`h-2 rounded-full ${warehouse.capacity > 80 ? 'bg-red-500' :
                                                warehouse.capacity > 60 ? 'bg-yellow-500' : 'bg-green-500'
                                            }`}
                                        style={{ width: `${warehouse.capacity}%` }}
                                    />
                                </div>
                                <p className="text-xs text-gray-500 mt-2">{warehouse.productsStored} products stored</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Add Warehouse Modal */}
            {showAddModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-lg">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">Add New Warehouse</h2>
                        <form className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Warehouse Name</label>
                                <input type="text" placeholder="Enter warehouse name" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                                <textarea rows={2} placeholder="Full address" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" />
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Manager Name</label>
                                    <input type="text" placeholder="Manager name" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Contact</label>
                                    <input type="tel" placeholder="Phone number" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                                </div>
                            </div>
                            <div className="flex gap-4 pt-4">
                                <button type="button" onClick={() => setShowAddModal(false)} className="flex-1 py-2 border border-gray-300 rounded-lg font-semibold text-gray-700 hover:bg-gray-50">Cancel</button>
                                <button type="submit" className="flex-1 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700">Add Warehouse</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SellerWarehouse;
